import { StrategicAxesRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: StrategicAxesRepository): Interactor {
  return (project) =>
    present(
      repository
        .getProjectStrategicAxes(project)
        .then((projectStrategicAxes) => ({ project, projectStrategicAxes }))
        .catch(() => Promise.reject(project)),
    );
}

export type { Interactor };

export { createInteractor };
